import { render } from "./HoldetsLys.vue?vue&type=template&id=98f5f1d8"
import script from "./HoldetsLys.vue?vue&type=script&lang=js"
export * from "./HoldetsLys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__